import { AuthenticationService } from "./../../core/authentication.service";
import { Injectable } from "@angular/core";

export interface BadgeItem {
  type: string;
  value: string;
}

export interface ChildrenItems {
  state: string;
  target?: boolean;
  name: string;
  type?: string;
  status?: boolean;
  children?: ChildrenItems[];
}

export interface MainMenuItems {
  state: string;
  main_state?: string;
  target?: boolean;
  name: string;
  type: string;
  icon: string;
  badge?: BadgeItem[];
  children?: ChildrenItems[];
}

export interface Menu {
  label: string;
  main: MainMenuItems[];
}

const MENUMEDECIN = [
  {
    label: "Tableau de Bord",
    main: [
      {
        state: "dashboard",
        name: "Tableau de Bord",
        type: "link",
        icon: "fa fa-dashboard"
      }
    ]
  },
  {
    label: "Menu",
    main: [
      {
        state: "admissions",
        name: "Admissions",
        type: "sub",
        icon: "fa fa-dot-circle-o",
        children: [
          {
            state: "admission",
            name: "Admissions"
          },
          {
            state: "rendezvous",
            name: "Rendez-Vous"
          },
          {
            state: "registre",
            name: "Registre Hemodialyse"
          },
          {
            state: "patient",
            name: "Patients"
          },
          {
            state: "attente",
            name: "Patient en Attente"
          }
          /*{
            state: "comptabilite",
            name: "Comptabilité"
          }*/
        ]
      },
      {
        state: "patients",
        name: "Dossiers Patients",
        type: "link",
        icon: "fa fa-user-circle"
      },
      {
        state: "consultations",
        name: "Consultations",
        type: "link",
        icon: "fa fa-user-md"
      },
      {
        state: "prescriptions",
        name: "Laboratoire",
        type: "link",
        icon: "fa fa-stethoscope"
      },
      {
        state: "pharmacie",
        name: "Pharmacie",
        type: "link",
        icon: "fa fa-medkit"
      },
      {
        state: "ephemeride",
        name: "Ephemerides",
        type: "link",
        icon: "fa fa-medkit"
      },
      {
        state: "dialyse",
        name: "Dialyse",
        type: "sub",
        icon: "fa fa-calendar",
        children: [
          {
            state: "planning-dialyse",
            name: "Planning Dialyse"
          },
          {
            state: "calendrier-dialyse",
            name: "Calendrier Dialyse"
          },
          {
            state: "cahier-dialyse",
            name: "Cahier de Dialyse"
          }
        ]
      },
      {
        state: "programmation-lots",
        name: "Programmation Lots",
        type: "link",
        icon: "fa fa-braille"
      },
      {
        state: "patientsimagerie",
        name: "Imagerie",
        type: "link",
        icon: "fa fa-newspaper-o"
      },
      {
        state: "comptabilite",
        name: "Comptabilité",
        type: "link",
        icon: "fa fa-drivers-license"
      },
      {
        state: "reporting",
        name: "Reporting",
        type: "link",
        icon: "fa fa-pie-chart"
      },
      /*{
        state: "comorbidite",
        name: "Comorbidite",
        type: "link",
        icon: "fa fa-bookmark"
      },*/
      {
        state: "parametrage",
        name: "Paramétrages",
        type: "sub",
        icon: "fa fa-cogs",
        children: [
          {
            state: "utilisateurs",
            name: "Utilisateurs"
          },
          {
            state: "consultationCategorie",
            name: "Consultation"
          },
          {
            state: "patients",
            name: "Patients"
          },
          {
            state: "parampersonnel",
            name: "Personnel"
          },
          {
            state: "pharmacie",
            name: "Pharmacie"
          },
          {
            state: "voie_dabord",
            name: "Voie dabord"
          },
          {
            state: "prescription_dialyse",
            name: "Prescription Dialyse Seance"
          },
          {
            state: "antecedent",
            name: "Antecedent"
          },
          {
            state: "dialyseur",
            name: "Dialyse"
          },
          {
            state: "matrimoniale",
            name: "Global"
          },
          {
            state: "comorbidite",
            name: "Comorbidite"
          }
        ]
      }
    ]
  }
];



@Injectable()
export class MenuItems {
  getAll(): Menu[] {


    return MENUMEDECIN;
    /*if (this.auth.hasRole("ADMINISTRATION")) {
      return MENUADMINISTRATION;
    } else if (this.auth.hasRole("MEDECIN")) {
      return MENUMEDECIN;
    } else if (this.auth.hasRole("INFIRMIER")) {
      return MENUINFIRMIER;
    }*/
  }

  constructor(private auth: AuthenticationService) {}
}



// WEBPACK FOOTER //
// /home/masdev/Documents/NEPHROSYSTEMLAST/nephrosystem-webapp/src/app/shared/menu-items/menu-items.ts